import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  RunTransition,
  RunTransitionWithDialog,
  WorkflowService,
} from 'src/app/shared/services/workflow/workflow.service';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeIconComponent } from '../../payee-icon/payee-icon.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-missed-installment-report',
  templateUrl: './missed-installment-report.component.html',
  styleUrls: ['./missed-installment-report.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeIconComponent,
    PayeeButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
})
export class MissedInstallmentReportComponent {
  private dialogRef =
    inject<MatDialogRef<MissedInstallmentReportComponent>>(MatDialogRef);
  private data = inject<RunTransitionWithDialog>(MAT_DIALOG_DATA);
  private workflowService = inject(WorkflowService);

  loading = false;

  readonly submit = async () => {
    const closeValue: RunTransition = {
      ...(this.data.extraParams ?? {}),
      caseId: this.data.caseId,
      transitionId: this.data.transitionId,
    };

    this.loading = true;
    try {
      await this.workflowService.runTransition(closeValue);
      this.dialogRef.close(closeValue);
    } catch (error) {
      this.workflowService.showTransitionError(error);
    } finally {
      this.loading = false;
    }
  };
}
